const API_URL = "https://tvlab-vpn.fe.dazn-stage.com";

export let regions;
export const fetchDevices = async () => {
  try {

    const response = await fetch(`${API_URL}/devices`);
    if (!response.ok) {
      throw new Error(
        `Failed to fetch data. Server returned status: ${response.status}`
      );
    }
    const data = await response.json();


    const deviceListResponse = await fetch("config/deviceList.json");

    if (!deviceListResponse.ok) {
      throw new Error(
        `Failed to fetch device list. Server returned status: ${deviceListResponse.status}`
      );
    }
    const deviceList = await deviceListResponse.json();

    const devices = Object.entries(deviceList).map(
      ([deviceName, deviceInfo]) => {
        const regionCode = Object.entries(data).find(
          ([deviceIP, _]) => deviceIP === deviceInfo.ip
        )?.[1];

        return {
          id: deviceInfo.ip,
          deviceName: deviceName,
          currentRegion: regionCode || "NONE"
        };
      }
    );

    // console.log("Processed devices:", devices); // Debug log
    return devices;
  } catch (error) {
    console.error("Error fetching devices:", error);
    throw error;
  }
};

export const fetchRegions = async () => {
  try {
    const response = await fetch(`${API_URL}/vpn`);
    if (!response.ok) {
      throw new Error(
        `Failed to fetch VPN regions. Server returned status: ${response.status}`
      );
    }
    const data = await response.json();
    regions = data;
    // console.log("Fetched regions:", regions); // Debug log
    return data;
  } catch (error) {
    console.error("Error fetching regions:", error);
    throw error;
  }
};

export const changeRegion = async (deviceId, region) => {
  let responseCode;

  try {

    const regionData = regions.find((r) => r.name === region);
    if (!regionData) {
      throw new Error(`There is no such region: ${region}.`);
    }
    const countryCode = regionData.countryCode;

    const response = await fetch(`${API_URL}/devices`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify([
        {
          ip: deviceId,
          region: countryCode,
        },
      ]),
    });
    responseCode = response.status;
    if (!response.ok) {
      throw new Error(
        `Failed to post VPN region data. Status: ${responseCode}`
      );
    }
    return responseCode;
  } catch (error) {
    console.error(
      "An error occurred while posting VPN region data:",
      error.message
    );
  }
};
